module.exports = __webpack_public_path__ + "483d7616d4c064360b87963263062b4d.svg";